import { RefundType } from './refund_types'

// refund and credit amount should always equal refund_owed
export interface Refund {
  type: RefundType;
  refund_amount: number;
  credit_amount: number;
}

export interface RefundRequest {
  type: RefundType;
  refund_amount: string;
  credit_amount: string;
}

export function refundToRequest(refund: Refund): RefundRequest {
  return {
    type: refund.type,
    refund_amount: refund.refund_amount.toFixed(2),
    credit_amount: refund.credit_amount.toFixed(2),
  }
}

// export interface RefundResponse {
//   overpayment: {
//     id: number;
//     ...Refund;
//     tax_return_id: number;
//     total_amount:number;
//   }
// }
